import React from "react";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import { onClickPurchaseUrl } from "../utils/utils";
import { useBundle } from "@amzn/react-arb-tools";
import { PRODUCTPAGE_MESSAGE_BUNDLE_NAME } from "src/constants";
import { t } from "src/helpers";

const PurchaseNowButton = ({ url }) => {
  const [bundle] = useBundle(PRODUCTPAGE_MESSAGE_BUNDLE_NAME);

  return (
    <Row>
      <Button type="primary" size="medium" onClick={onClickPurchaseUrl(url)}>
        {t(bundle, "purchase_now")}
      </Button>
    </Row>
  );
};

export default PurchaseNowButton;
